var s={searchSuggestions:"rl2_searchSuggestions-module_searchSuggestions_ZrQ6c",title:"rl2_searchSuggestions-module_title_V-vCj",suggestionsRow:"rl2_searchSuggestions-module_suggestionsRow_rsVKQ"};export{s as default};
